import React from 'react'
import { Grid, MenuItem, TextField } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux'
import { useUnmount } from 'react-use'
import Autocomplete from '~/components/Autocomplete'
import { Creators as RhDashboardActions } from '~/store/ducks/rhDashboard'

const rhDashboardSelector = ({ rhDashboard }) => rhDashboard

function RhDashboardFilters() {
  const { filtersData, filters } = useSelector(rhDashboardSelector)
  const dispatch = useDispatch()

  useUnmount(() => {
    dispatch(RhDashboardActions.resetRhDashboard())
  })

  function handleChangeFilter(property, value) {
    if (property === 'group') {
      dispatch(RhDashboardActions.setRhDashboardGroupFilter(value))
    } else {
      dispatch(RhDashboardActions.setRhDashboardFilter(property, value))
    }
  }

  const colDateToFilterOptions = [
    { id: 'hired', name: 'Contratação' },
    { id: 'working', name: 'Trabalho' },
  ]

  return (
    <Grid container spacing={2}>
      <Grid item md={3} sm={6} xs={12}>
        <TextField
          variant="outlined"
          label="Grupos"
          fullWidth
          select
          value={filters.group}
          onChange={(ev) => handleChangeFilter('group', ev.target.value)}
        >
          {filtersData.groups.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item md={3} sm={6} xs={12}>
        <TextField
          variant="outlined"
          label="Departamentos"
          fullWidth
          select
          value={filters.department}
          onChange={(ev) => handleChangeFilter('department', ev.target.value)}
        >
          {filtersData.departments.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item md={3} sm={6} xs={12}>
        <TextField
          variant="outlined"
          label="Vínculo"
          fullWidth
          select
          value={filters.bond}
          onChange={(ev) => handleChangeFilter('bond', ev.target.value)}
        >
          {filtersData.bonds.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6} md={3} >
        <Autocomplete
          onChange={(_, option) => {
            handleChangeFilter('dealership_context', option ? option.value : 'working')
          }}
          options={colDateToFilterOptions?.map((option) => ({
            label: option.name,
            value: option.id,
          }))}
          name="dealership_context"
          value={filters.dealership_context}
          label="Concessionária de"
          placeholder="Concessionária de contratação ou trabalho"
        />
      </Grid>
    </Grid>
  )
}

RhDashboardFilters.propTypes = {}

export default RhDashboardFilters
